export const elevations = {
  '00': 'none',
  '01': '0px 2px 4px 0px rgba(0, 0, 0, 0.24)',
  '02': '0px 4px 8px 0px rgba(0, 0, 0, 0.24)',
  '03': '0px 8px 16px 0px rgba(0, 0, 0, 0.24)',
};
